import { ListItemAvatar } from '../../../../ExternalLibraries';

export default ListItemAvatar;
